import { Button } from "@/components/ui/button";

interface BankStatementHeaderProps {
  onImportClick: () => void;
  onExportClick: () => void;
}

export function BankStatementHeader({
  onImportClick,
  onExportClick,
}: BankStatementHeaderProps) {
  return (
    <div className="flex items-center gap-[10px]">
      <Button
        size="sm"
        variant="secondary"
        onClick={onImportClick}
      >
        Importar
      </Button>

      <Button
        size="sm"
        variant="secondary"
        className="bg-purple-50 hover:bg-purple-50/90 text-purple-500"
        onClick={onExportClick}
      >
        Exportar
      </Button>
    </div>
  );
}

BankStatementHeader.displayName = "BankStatementHeader";
